module.exports = __webpack_public_path__ + "img/rpf.b559950c.jpg";